export default "__VITE_ASSET__BeMdgK$Z__"